import React from "react";
import { useHistory } from "react-router-dom";

import "./Expired.styles.scss";
import { Button } from "components/forms";
import { Routes } from "../../constants/routes";

export const Expired: React.FC = () => {
  const { replace } = useHistory();

  return (
    <div className="page flex-col-fc-fc">
      <div className="expired-error flex-col-fc-fc">Your invitation has expired</div>
      <span className="expired-title">Please contact the person who invited you for a new invitation</span>
      <span className="expired-subtitle">
        If you already have an active account in Altius, go to your account to see your deals
      </span>
      <div className="not-found__redirection flex-row-fc-fc">
        <Button
          className="not-found__redirection-home"
          variant="square"
          title="Go to Altius"
          onClick={() => replace(Routes.login)}
        />
        <a
          href="https://form.asana.com/?k=e_olgIBpwIAsjPgN7Cd9aQ&d=1179264452013401"
          className="link link__contact-us no-outline scale-click"
        >
          Contact us
        </a>
      </div>
    </div>
  );
};
